import getUUID from 'uuid-by-string';

export class Track {
  constructor(id, position, trackNumber, title, duration, description, bpm, key, locationLocal, streamSpotifyId, genre) {
    this.id = id;
    this.trackNumber = trackNumber;
    this.position = position;
    this.title = title;
    this.duration = duration;
    this.description = description;
    this.bpm = bpm;
    this.key = key;
    this.locationLocal = locationLocal;
    this.streamSpotifyId = streamSpotifyId;
    this.genre = genre;
  }

  convertTracksFromDiscogs(index, data) {
    this.title = data.title;
    this.trackNumber = index;
    this.trackNumber = data.position;
    this.duration = parseInt(data.duration, 10);
    return this;
  }

  convertTracksFromLastFm(data) {
    this.title = data.name;
    this.trackNumber = parseInt(data['@attr'].rank, 10);
    this.duration = parseInt(data.duration, 10);
    return this;
  }
}

const albumPreviewModel = album => ({
  masterId: album.masterId,
  id: album.id,
  title: album.title,
  artist: album.artist,
  image: album.image,
});

const albumModel = album => ({
  id: album.id,
  title: album.title,
  artist: album.artist,
  image: album.image,
  trackList: album.trackList,
  genres: album.genres,
});

export const albumFromSearchLastFM = (album) => {
  const loccalAlbumModel = {
    id: album.mbid,
    title: album.name,
    artist: album.artist,
  };

  if (album.image && album.image[3]) {
    loccalAlbumModel.image = album.image[3]['#text'];
  }

  return albumPreviewModel(loccalAlbumModel);
};

export const albumFromSearchDiscogs = (album) => {
  console.log(album)
  const localAlbumModel = {
    masterId: album.master_id,
    id: album.id,
    title: album.title,
    artist: album.artist,
    image: album.cover_image || album.images[0].uri,
  };

  return albumPreviewModel(localAlbumModel);
};

export const albumInfoFromLastFM = (album) => {
  const loccalAlbumModel = {
    id: album.id || getUUID(`${album.artist}-${album.name}`),
    title: album.name,
    artist: album.artist,
    trackList: [],
  };

  if (album.image && album.image[3]) {
    loccalAlbumModel.image = album.image[3]['#text'];
  }

  album.tracks.track.forEach(track => loccalAlbumModel.trackList.push(new Track().convertTracksFromLastFm(track)));

  return loccalAlbumModel;
};

export const albumInfoFromDiscogs = (album) => {
  console.log(album)
  const artist = album.artists[0].name;
  const localAlbumModel = {
    id: getUUID(`${artist}-${album.name}`),
    masterId: album.masterId,
    title: album.title,
    artist,
    trackList: album.tracklist.map((track, index) => new Track().convertTracksFromDiscogs(index, track)),
    genres: album.genres,
  };

  if (album.images && album.images[0]) {
    localAlbumModel.image = album.images[0].uri;
  }

  console.log('mutate', albumModel(localAlbumModel))
  return albumModel(localAlbumModel);
};

export class Album {
  constructor(id, title, artist, trackList = [], image, releaseDate) {
    this.id = id;
    this.title = title;
    this.artist = artist;
    this.trackList = trackList;
    this.image = image;
    this.releaseDate = releaseDate;
  }

  convertAlbumInfoFromLastFm(data) {
    this.id = data.id || getUUID(`${data.artist}-${data.name}`);
    this.title = data.name;
    this.artist = data.artist;
    this.image = data.image[3]['#text'];

    data.tracks.track.forEach(track => this.trackList.push(new Track().convertTracksFromLastFm(track)));
    return this;
  }
}

export default Album;

/*
const artist = {
  id: null,
  name: null,
  albumList: [],
};

class Artist {
  constructor(id, name, albumList) {
    this.id = id;
    this.name = name;
    this.albumList = albumList;
  }
}

const album = {
  id: null,
  title: null,
  releaseDate: null,
  artist: null,
  image: null,
  trackList: [],
};
*/
